import { Component, OnInit, ViewChild,Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import {MatTableDataSource, MatPaginator } from '@angular/material';
import { UserService } from 'src/app/shared/services/user.service';
import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrls: ['./user-table.component.css']
})
export class UserTableComponent implements OnInit {

  displayedColumns: string[] =  ['UserName','Password','FirstName','LastName',"Edit"];
  post:any;
  public resultdata:any;
  UserData:any;
  dataSource;
  errorMessage: String;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private _userervice:UserService, changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this._userervice.refreshNeeded$
    .subscribe(()=>{
      this.getAllUser();
    })
    this.getAllUser();
    }

  getAllUser() {
      this._userervice.getAllRole(AppSettings.API_ENDPOINT+AppSettings.GetAllUsers)
      .subscribe(result =>{
        this.resultdata=result;
        console.log(result)
        if(!result){
         return;
      }
  
      this.dataSource = new MatTableDataSource(this.resultdata);
      this.dataSource.paginator = this.paginator;
    });
  }

onEditUser(param:any):void{
  var o={PK_UserID:param.PK_UserID}
   this.post=JSON.stringify(o);
   this._userervice.GetUserByID(AppSettings.API_ENDPOINT+AppSettings.GetUserByID,this.post).subscribe(
     data => {
            this.UserData=data;
            this.messageEvent.emit(this.UserData);
       },
      error => this.errorMessage = <any>error)
}

// onDeleteBatch(param:any):void{
// var o={PK_BatchID:param.PK_BatchID}
//   this.post=JSON.stringify(o);
//   this._userervice.deleteUser(AppSettings.API_ENDPOINT+AppSettings.DeleteBatch,this.post).subscribe(
//    data => {
//       this.httpResponseMessage=data;
//       this.openSnackBar(this.httpResponseMessage,'');
//      },
//       error => this.errorMessage = <any>error)
//   }
}